export default function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/node_modules/@babel/runtime/helpers/esm/typeof.js
// module id = 672
// module chunks = 0